export const columns = (vm) =>{
  return [
      {
          width:50,
          headerAlign:"center",
          align:"center",
          type:'selection',
      },
      // {
      //   type: 'index',
      //   width: 50,
      //   label: '序号',
      //   headerAlign:"center",
      //   align:"center",
      // },
      {
        prop: 'resourcesUrl',
        label: '产品图片',
        minWidth: '120',
        tooltip: true,
        render: (h, params) => {
            return h('div', {
                style: {
                    display: 'flex',
                    alignItem: 'center',
                }
            }, [
                h('img', {
                    attrs: {
                        src: params.row.resourcesUrl,
                        width: '32',
                        height: '32',
                    },
                })
            ]);
        }
      },
      {
          label:'序列号',
          prop:'serialNo',
          align:'center',
          headerAlign:'center',
          tooltip:true,
      },
      {
          label:'产品名称',
          prop:'productName',
          align:'center',
          headerAlign:'center',
      },
      {
          label:'位置区域',
          prop:'address',
          align:'center',
          headerAlign:'center',
          width:300,
      },
      {
          label:'接收方式',
          prop:'deviceConfig',
          align:'center',
          headerAlign:'center',
          width:130,
          render:(h,params)=>{
            if(params.row.deviceConfig == null || params.row.deviceConfig == undefined || params.row.deviceConfig.length == 0){
              return h('div',{
                style: {
                    display: 'flex',
                    alignItem: 'center',
                }
              },'')
            }
  
            let arr = [];
  
            params.row.deviceConfig.oaState?arr.push('公众号'):'';
            params.row.deviceConfig.shortMessageState?arr.push('短信'):'';
            params.row.deviceConfig.voiceState?arr.push('语音'):'';
  
  
            let txt = arr.join(',');
            return h('div', {
                style: {
                    display: 'flex',
                    alignItem: 'center',
                }
            },txt)}
      },
      {
          label:'接收人员',
          width:160,
          prop:'roleType',
          align:"center",
          headerAlign:"center",
          render:(h,params)=>{
            if(params.row.deviceConfig == undefined || params.row.deviceConfig == null || params.row.deviceConfig.pushUserList == null || params.row.deviceConfig.pushUserList == undefined || params.row.deviceConfig.pushUserList.length == 0){
                return h('div',{
                    style: {
                        display: 'flex',
                        alignItem: 'center',
                    }
                },'')
                }

                let arr = [];
                params.row.deviceConfig.pushUserList.forEach((item,index)=>{
                arr.push(item.userName);
                })

                let txt = arr.join(',')
                return h('div', {
                    style: {
                        display: 'flex',
                        alignItem: 'center',
                    }
                },txt)
          }
      },
      {
        label:'更新时间',
        width:160,
        prop:'updateTime',
        align:"center",
        headerAlign:"center",
        // render:(h,param)=>{
        //   return h('div',{},param.row.updateTime);
        // }
    }
      // {
      //     label:'操作',
      //     width:120,
      //     align:"center",
      //     headerAlign:"center",
      //     render: (h, params) => {
      //         let del = (h)=>{
      //             return h('el-button',{
      //                 props:{
      //                     type:'text'
      //                 },
      //                 style:{
      //                     padding:0
      //                 },
      //                 on:{
      //                     click:()=>{vm.operateShow(2,params.row)}
      //                 }
      //             },'删除')
      //         }

      //         let query = (h)=>{
      //             return h('el-button',{
      //                 props:{
      //                     type:'text'
      //                 },
      //                 style:{
      //                     padding:0
      //                 },
      //                 on:{
      //                     click:()=>{vm.operateShow(1,params.row)}
      //                 }
      //             },'查看')
      //         }

      //         let btnArr = [];
      //         btnArr.push(query(h));
      //         btnArr.push(del(h));

      //         return h('div',{},btnArr)
      //     }
      // }
    ]
}